/* eslint-disable @nx/enforce-module-boundaries */
import { Avatar, HStack, Link, Stack, Text,Box } from '@mybridge/ui';
import { forwardRef } from 'react';
import {
  formatLocation,
  getUserFullName,
  getUserProfilePic,
} from 'v4/lib/commons';
import { useSelector } from 'react-redux';
import { TeamIcon } from '@mybridge/icons';
export const UserCard = forwardRef(({ user = {}, ...props }, ref) => {
  const name = getUserFullName(user);
  const { allConnectionIDs } = useSelector((state) => state.connection);
  const { circle, followers } = allConnectionIDs ?? {};
  const profile_pic = getUserProfilePic(user);
  const { position, location, experience } = user ?? {};
  // console.log('user', experience);
  return (
    <>
      <HStack {...props}>
        <Avatar
          name={name}
          {...(profile_pic?.length ? { src: profile_pic } : {})}
        />

        <Stack spacing={0} flex={1}>
          <HStack spacing="4px" alignItems="center">
            {name ? (
              <Text
                as={Link}
                href={`/p/${user?.slug}`}
                fontSize="16px"
                color="brandPrimary.500"
              >
                {name}
              </Text>
            ) : null}

            {circle?.length ? (
              <>
                {/* Wrapping the icon in Box to control size */}
                <Box>
                  <TeamIcon width="10px" height="10px" color="#868585" fontSize="inherit" />
                </Box>
                <Text fontSize="12px" color="blackAlpha.500">
                  {circle.length + followers.length}
                </Text>
              </>
            ) : null}
          </HStack>

          {/* {experiences?.length ? (
            <Text fontSize="sm">
              {experiences?.[0]?.title}, {experiences?.[0]?.company_name}
            </Text>
          ) : (
            ''
          )} */}
          {experience ? (
            <Text fontSize="11px">
              {experience?.[0]?.title ?? experience?.title},{' '}
              {experience?.[0]?.company_name ?? experience?.company_name}
            </Text>
          ) : (
            ''
          )}
          {location ? (
            <Text fontSize="10px" color="blackAlpha.500">
              {formatLocation(user)}
            </Text>
          ) : (
            ''
          )}
        </Stack>
      </HStack>
    </>
  );
});
